export class DeviceUtils {
  static isTouch() {
    if (!global.isClientSide) {
      return false;
    }
    return window.matchMedia("(pointer:coarse)").matches;
  }
  static isMobile() {
    if (!global.isClientSide) {
      return false;
    }

    return window.innerWidth < 768;
  }

  static isTablet() {
    if (!global.isClientSide) {
      return false;
    }

    return window.innerWidth < 1024 && window.innerWidth > 767;
  }

  static isDesktop() {
    if (!global.isClientSide) {
      return false;
    }

    return window.innerWidth > 1023;
  }
}
